import InternalStaticAnchorNotificationList from 'models/application/anchor/types/internalStatic/types/NotificationList';

export default class InternalStaticAnchorNotificationListService {
	toModel(anchor) {
		return new InternalStaticAnchorNotificationList(anchor);
	}
}
